import React from "react";

const CustomTooltip = (props) => {
  return (
    <div
      style={{
        padding: "8px 10px",
        backgroundColor: "var(--ag-tooltip-background-color, #f8f8f8)",
        color: "var(--ag-tooltip-color, #333)",
        borderRadius: "4px",
        fontSize: "var(--ag-font-size, 13px)",
        fontFamily: "var(--ag-font-family, inherit)",
        maxWidth: "400px",
        minWidth: "120px",
        wordWrap: "break-word",
        whiteSpace: "pre-wrap",
        overflowY: "auto",
        maxHeight: "200px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        zIndex: 999999,
        position: "relative",
        boxSizing: "border-box",
      }}
    >
      {props.value}
    </div>
  );
};

export default CustomTooltip;
